module.exports = __webpack_public_path__ + "img/sc.5b67a760.png";